import { render, staticRenderFns } from "./query-header.vue?vue&type=template&id=280c82ea&"
import script from "./query-header.vue?vue&type=script&lang=ts&"
export * from "./query-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports